// extracted by mini-css-extract-plugin
export default {"withIcon":"SelectRoleSingleValue-module__withIcon___h1asC","disabled":"SelectRoleSingleValue-module__disabled____VbnI"};